import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';

interface SaveBookingConfigButtonProps {
  isSaving: boolean;
  disabled: boolean;
  onSave: () => void;
}

export const SaveBookingConfigButton: React.FC<SaveBookingConfigButtonProps> = ({ isSaving, disabled, onSave }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'end', mt: 4, mb: 2 }}>
      <Button
        type="button"
        variant="contained"
        size="large"
        startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
        onClick={onSave}
        disabled={disabled || isSaving}
        sx={{
          px: 6, py: 1.5,
          boxShadow: '0 8px 16px rgba(25, 118, 210, 0.2)',
          borderRadius: '30px',
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '1rem'
        }}
      >
        {isSaving ? 'Saving...' : 'Save Configuration'}
      </Button>
    </Box>
  );
};
